import styled from 'styled-components';
import media from '../../../../constants/media';

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 3rem;

	${media.mobileOnly`
		flex-direction: column;

		button {
			width: 100%;

			&:first-child {
				margin-bottom: 1.5rem;
			}
		}
	`};
`;
